import { Params } from '@angular/router';
import { IgMedia } from '@core/models/ApiFields/ig-entities';
import { OnlyPagination, IData, ReqMode } from '@core/models/IApi';
import { Sorting } from '@features/social-analysis/models/ITable';
import { IG_ENDPOINT } from '@features/social-analysis/social-listening/config/api-params';
import { PageFiltersState } from '@features/social-analysis/social-shared/store/page-filters.store';
import { TableState } from '@features/social-analysis/social-shared/store/table.store';
import { finalize } from 'rxjs/operators';
import { HttpBuilder } from './http-builder';

export abstract class TableHttpBuilder<T extends IData = IData> extends HttpBuilder {
    reqData(state: TableState<T>, pageFilters: PageFiltersState, needsTotal?: boolean) {
        const url = this.buildUrl(IG_ENDPOINT);
        const params = this.buildParams(state, pageFilters, 1);

        state.isLoading.set(true);
        this.makeGetReq(url, params, state);

        if (needsTotal) this.reqTotal(state, pageFilters);
    }

    reqTotal(state: TableState<T>, pageFilters: PageFiltersState) {
        const url = this.buildUrl(IG_ENDPOINT);
        const params = this.buildParams(state, pageFilters, 2);

        // state.isLoading.set(true);

        this.http
            .get<OnlyPagination>(url, { params: params })
            .pipe(finalize(() => state.isLoading.set(false)))
            .subscribe({
                next: res => state.total.set(res.total),
                error: err => this.handleError(err?.error?.message),
            });
    }

    protected abstract buildParams(
        { limit, offset, sorting }: TableState<T>,
        pageFilters: PageFiltersState,
        mode: ReqMode
    ): Params;

    protected formatSorting(sort: Sorting[], hiddenSort: Sorting[] = []) {
        const temp = sort.length ? sort : hiddenSort;
        const parsed = this.formatSpecialSorts(temp);
        return parsed.map(sort => `${sort.prop}_${sort.dir}`).join();
    }

    private formatSpecialSorts(sorting: Sorting[]) {
        return sorting.map(sort =>
            sort.prop === IgMedia.getPrefixed('commentsPositivity') && sort.dir === 'asc'
                ? { prop: IgMedia.getPrefixed('commentsNegativity'), dir: 'desc' }
                : sort
        );
    }
}
